<template>
    <div class="request">
        <img src="/images/home/form_bg.png" alt="Услуги перевозок в Беларусь" class="request-bg">
        <div class="contact-form-container">
            <div class="contact-form-text">
                <p class="contact-form-block__title">Остались вопросы?</p>
                <p class="contact-form-block__subtitle" >Задайте их в форме обратной связи или позвоните по тел.
                    <br>
                    <a class="contact-form-block__subtitle-link"
                        @click="telClick"
                        href="tel:375173361999">
                        +375 (17) 336-19-99
                    </a>
                </p>
            </div>
            <Form key="main-page-form"/>
        </div>
    </div>
</template>

<script setup>
import Form from '~/components/home/Form.vue';
</script>

<style scoped>
.request {
    position: relative;
    display: flex;
    justify-content: right;
    align-items: end;
    padding: 80px 0;
    padding-right: 320px;
    overflow: hidden;
}

.request-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.contact-form-container {
    position: relative;
    z-index: 1;
    padding: 32px;
    background-color: #FFFFFF;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    max-width: 628px;
}

.contact-form-text {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.contact-form-block__title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    text-align: center;
    margin: 0;
}

.contact-form-block__subtitle  {
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    text-align: center;
    margin: 0;
}

.contact-form-block__subtitle-link  {
    font-weight: 700;
    font-style: Bold;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    text-align: center;
    margin: 0;
    color: #48538B;
}

.contact-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media (max-width: 1279px) {
    .request {
        justify-content: center;
        padding: 32px;
    }
    .contact-form-container {
        max-width: 100%;
    }

}

@media (max-width: 768px) {
    .request {
        padding: 16px;
    }
}
</style>
